import React from 'react';

const PageNotFound = React.lazy(() => import('./PageNotFound' /* webpackChunkName: "PageNotFound" */));
const PageNotFoundInitializer = () => (
    <PageNotFound />
);
export default PageNotFoundInitializer;
